module.exports = __webpack_public_path__ + "static/media/28.a700b2f4.jpg";